import { render, staticRenderFns } from "./chooseWay.vue?vue&type=template&id=44ec8cbc&scoped=true&"
import script from "./chooseWay.vue?vue&type=script&lang=js&"
export * from "./chooseWay.vue?vue&type=script&lang=js&"
import style0 from "./chooseWay.vue?vue&type=style&index=0&id=44ec8cbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ec8cbc",
  null
  
)

export default component.exports